export default class AttendanceoService {
  constructor(http) {
    this.http = http;
  }

  async findAttendanceWithDatesClassByConditions(queryConditions = {}) {
    // conditions 객체를 쿼리 문자열로 변환
    // console.log("regi conditions", conditions);
    const queryParams = Object.entries(queryConditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    // console.log("queryParams", queryParams);
    return this.http.fetch(
      `/api/attendance/readattendancewithdatesclass?${queryParams}`,
      {
        method: "GET",
      }
    );
  }

  async createAttendance(attendanceInfo) {
    return this.http.fetch(`/api/attendance/create`, {
      method: "POST",
      body: JSON.stringify(attendanceInfo),
    });
  }

  async updateAttendance(attendanceInfo) {
    return this.http.fetch(`/api/attendance/update`, {
      method: "PUT",
      body: JSON.stringify(attendanceInfo),
    });
  }

  // async deleteAttendance(id) {
  //   return this.http.fetch(`/api/attendance/delete`, {
  //     method: "DELETE",

  //     body: JSON.stringify({ id }),
  //   });
  // }
}
